(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    function syncNewsletterBannerImageHeight(scope = document) {
      const banners = scope.querySelectorAll('.footer-content--newsletter-banner');

      banners.forEach((banner) => {
        const contentBlock = banner.firstElementChild;
        const imageBlock = banner.lastElementChild;
        const image = imageBlock?.querySelector('.image-block__image, .placeholder-image');

        if (!contentBlock || !imageBlock || !image) return;

        const contentHeight = contentBlock.getBoundingClientRect().height;

        if (!contentHeight) return;

        const resolvedHeight = contentHeight;

        banner.style.setProperty('--newsletter-banner-content-min-height', `${resolvedHeight}px`);

        if (!mobileQuery.matches) {
          imageBlock.style.removeProperty('height');
          image.style.removeProperty('height');
          return;
        }

        imageBlock.style.height = `${resolvedHeight}px`;
        image.style.height = `${resolvedHeight}px`;
      });
    }

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const banner = entry.target.closest('.footer-content--newsletter-banner') || entry.target;
        syncNewsletterBannerImageHeight(banner.parentNode || document);
      });
    });

    function observeNewsletterBanners(scope = document) {
      scope.querySelectorAll('.footer-content--newsletter-banner').forEach((banner) => {
        const contentBlock = banner.firstElementChild;
        if (contentBlock) resizeObserver.observe(contentBlock);
      });
      syncNewsletterBannerImageHeight(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => observeNewsletterBanners());
    } else {
      observeNewsletterBanners();
    }

    window.addEventListener('resize', () => syncNewsletterBannerImageHeight());
    mobileQuery.addEventListener('change', () => syncNewsletterBannerImageHeight());
    document.addEventListener('shopify:section:load', (event) => observeNewsletterBanners(event.target));
    document.addEventListener('shopify:block:select', () => syncNewsletterBannerImageHeight());
  })();

  } catch(e) { console.error(e); }
})();
})();
